var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1174,
    height: 1175,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1613,
    y: 650,
    width: 1174,
    height: 1175
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-1613 -650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1821 934 1821 913 1951 913 1951 934Z",
    fill: "#564EA0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1865 978 1865 957 1995 957 1995 977.868Z",
    fill: "#564EA0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1798 913 1798 934 1777 934 1777 913Z",
    fill: "#564EA0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2085.71 1297.81C2098.95 1314.67 2091.66 1333.75 2094 1352L2072.18 1352 2072.18 1323.42C2072.18 1312.43 2068.41 1308.67 2057.56 1308.63L2039.82 1308.63 2039.82 1351.91 2018.39 1351.91C2018.39 1350.21 2018 1348.24 2018 1346.31L2018 1256.67C2018 1246.69 2021.51 1243.1 2031.36 1243.06L2059.82 1243.06C2072.4 1242.28 2084.23 1249.17 2089.84 1260.57 2096.07 1271.59 2095.09 1285.31 2087.36 1295.32 2086.76 1296.12 2086.21 1296.95 2085.71 1297.81ZM2039.82 1286.79C2047.54 1286.79 2054.96 1287.27 2062.29 1286.79 2067.89 1286.55 2072.28 1281.85 2072.18 1276.19 2072.43 1270.44 2068.11 1265.52 2062.42 1265.08 2055.05 1264.59 2047.67 1265.08 2039.95 1265.08Z",
    fill: "#564EA0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2137.83 1264.61 2137.83 1286.46 2169.8 1286.46 2169.8 1308.31 2138.22 1308.31 2138.22 1330.15 2181 1330.15 2181 1352 2128.12 1352C2119.98 1352 2116.04 1347.98 2116 1339.77L2116 1255.22C2116 1247.88 2119.59 1243.2 2126.06 1243.12 2144.21 1242.85 2162.37 1243.12 2180.96 1243.12L2180.96 1264.48Z",
    fill: "#564EA0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2269 1351.99 2214.6 1351.99C2209.03 1352.24 2204.31 1347.91 2204.05 1342.31 2204.05 1341.83 2204.05 1341.35 2204.05 1340.87L2204.05 1254.13C2203.52 1248.59 2207.56 1243.67 2213.08 1243.14 2213.09 1243.14 2213.11 1243.14 2213.12 1243.14L2213.69 1243.14C2231.97 1242.83 2250.29 1243.14 2268.96 1243.14L2268.96 1264.68 2226.08 1264.68 2226.08 1286.57 2257.96 1286.57 2257.96 1308.47 2226.16 1308.47 2226.16 1330.71 2269 1330.71Z",
    fill: "#564EA0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1995 1243.04 1995 1264.62 1951.94 1264.62 1951.94 1286.54 1983.79 1286.54 1983.79 1308.46 1951.77 1308.46 1951.77 1352 1930.31 1352C1930.31 1349.85 1930 1347.62 1930 1345.47L1930 1257.21C1930 1246.38 1933.36 1243.04 1944.27 1243Z",
    fill: "#564EA0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 78.9214 78.9214",
    stroke: "#564EA0",
    strokeWidth: 13.75,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 2544 1177.92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 78.9214 78.9214",
    stroke: "#564EA0",
    strokeWidth: 13.75,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 2599 1177.92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 78.9214 78.9214",
    stroke: "#564EA0",
    strokeWidth: 13.75,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 2544 1117.92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1771.5 1145.31 1771.5 1015.5 2503.5 1015.5 2503.5 1203.5",
    stroke: "#564EA0",
    strokeWidth: 19.4792,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.5 1214.5 1768.5 1449.5",
    stroke: "#564EA0",
    strokeWidth: 19.4792,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2336.5 1558.52 1763.26 1561.5C1763.26 1561.5 1708.31 1546.6 1727.61 1482.5L2333.53 1485.48",
    stroke: "#564EA0",
    strokeWidth: 19.4792,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2554.5 1236.5 2366.5 1236.5 2366.5 1562.5 2548.53 1562.5 2548.53 1473.19",
    stroke: "#564EA0",
    strokeWidth: 19.4792,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2406.5 1294.5 2513.5 1294.5",
    stroke: "#564EA0",
    strokeWidth: 19.4792,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2408.5 1480.5 2515.5 1480.5",
    stroke: "#564EA0",
    strokeWidth: 19.4792,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2439.5 1523.5 2482.5 1523.5",
    stroke: "#564EA0",
    strokeWidth: 19.4792,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2045.5 1085.5 2154.5 1194.5",
    stroke: "#564EA0",
    strokeWidth: 19.4792,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2064.5 1170.5 2107.5 1208.5",
    stroke: "#564EA0",
    strokeWidth: 19.4792,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFree);
export default __webpack_public_path__ + "static/media/free.574fa9d5605b803cfbca8f03560828d3.svg";
export { ForwardRef as ReactComponent };